import React from 'react'
import Link from 'gatsby-link'

import ICONS_BOTOX from '../img/services/botox.svg'
import ICONS_CONSULTATION from '../img/services/consultation.svg'
import ICONS_ASSESMENT from '../img/services/assesment.svg'
import ICONS_JUVEDERM from '../img/services/juvederm.svg'
import ICONS_SKINCARE from '../img/services/skincare.svg'
import ICONS_BD from '../img/services/bd.png'

import ICONS_CHEVRON_RIGHT from 'react-icons/lib/md/chevron-right'

const SERVICES = [
    {
        title: 'FREE Consultation',
        image: ICONS_CONSULTATION,
        route: 'services-free-consultation'
    },
    {
        title: 'Medical Assessment',
        image: ICONS_ASSESMENT,
        route: 'services-medical-assessment'
    },
    {
        title: 'Botox',
        image: ICONS_BOTOX,
        route: 'services-botox'
    },
    {
        title: 'Juvederm Fillers',
        image: ICONS_JUVEDERM,
        route: 'services-juvederm-fillers'
    },
    {
        title: 'Skin Care Products',
        image: ICONS_SKINCARE,
        route: 'services-skincare-products'
    },
    {
        title: 'Brilliant Distinctions',
        image: ICONS_BD,
        route: 'services-brilliant-distinctions'
    }
]

export default class Services extends React.Component {
    render() {
        return (
            <div className="container marginTop-60" id="services">
                <div className="columns">
                    <div className="column">
                        <div className="title-bar marginTop-30">
                            <h4>
                                Services
                  </h4>

                            <p>
                                Please call us to book a consultation
                  </p>
                        </div>

                        <div className="columns is-multiline marginTop-30 is-mobile">
                            {SERVICES.map((item, index) =>
                                <div className="column service is-one-third" key={`service-${index}`}>
                                    <Link to={`/${item.route}`}>
                                        <div style={{ maxWidth: '300px', display: 'table' }}>
                                            <div className="photo">
                                                <img src={item.image} />
                                            </div>

                                            <span className="title">
                                                {item.title}
                                            </span>

                                            <ICONS_CHEVRON_RIGHT size={25} />
                                        </div>
                                    </Link>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/__components/Services.js